var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 9.33333H7.99999M7.99999 9.33333H9.33332M7.99999 9.33333V10.6667M7.99999 9.33333V8",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 4.63321C1.33334 4.04485 1.33334 3.75067 1.37958 3.50563C1.5831 2.42691 2.42688 1.58313 3.5056 1.37961C3.75064 1.33337 4.04482 1.33337 4.63318 1.33337C4.89096 1.33337 5.01985 1.33337 5.14372 1.34496C5.67778 1.3949 6.18436 1.60473 6.5973 1.94705C6.69309 2.02645 6.78423 2.11759 6.96651 2.29987L7.33334 2.66671C7.8772 3.21056 8.14912 3.48249 8.47475 3.66366C8.65364 3.76318 8.84338 3.84178 9.04024 3.89789C9.39861 4.00004 9.78317 4.00004 10.5523 4.00004H10.8014C12.5563 4.00004 13.4338 4.00004 14.0041 4.51302C14.0566 4.5602 14.1065 4.61013 14.1537 4.66259C14.6667 5.23294 14.6667 6.1104 14.6667 7.86531V9.33337C14.6667 11.8475 14.6667 13.1046 13.8856 13.8857C13.1046 14.6667 11.8475 14.6667 9.33334 14.6667H6.66668C4.15252 14.6667 2.89544 14.6667 2.11439 13.8857C1.33334 13.1046 1.33334 11.8475 1.33334 9.33337V4.63321Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/addFolder.6d93029cf7707569d9c5488d43abf920.svg";
export { ForwardRef as ReactComponent };